import React, { useState } from "react";
import GooglePlacesMulti2 from "components/shared/GooglePlacesMulti2";
import { uploadFileMulti_ } from "helpers/uploadFile";
import * as actions from "store/actions/index.js";
import { MAIN__DUMMY_ } from "utils/constant";

export default ({
  setAcademyData,
  academyData,
  dispatch,
  setIsShow,
  setSending,
  setPreviewImage,
  setSelectedFile,
  setValidationErrors,
  previewImage,
  editData,
  fileInputRef2,
  handleDrop,
  handleDragOver,
  handleClick2,
}) => {
  //academy address
  const handleChangeForm = async (index, event, fieldName) => {
    if (event.target.type === "file") {
      let res = await handleFileChange(event);
      const newForms = [...academyData];
      newForms[index]["academy_image"] = res.image_url;
      newForms[index]["academy_image_thumb"] = res.thumbnail_url;
      setAcademyData(newForms);
    } else {
      const newForms = [...academyData];
      newForms[index][fieldName] = event.target.value;
      setAcademyData(newForms);
    }
  };
  const handleAddForm = () => {
    // Add a new form if all existing forms are valid
    setAcademyData((prev) => [
      ...prev,
      {
        academy_name: "",
        academy_description: "",
        academy_image: "",
        academy_image_thumb: "",
        academy_location: "",
        academy_latitude: "",
        academy_longitude: "",
      },
    ]);
  };

  const handleRemoveForm = (index) => {
    const newForms = [...academyData];
    newForms.splice(index, 1);
    setAcademyData(newForms);
  };
  const handleFileChange = async (e) => {
    e.preventDefault();
    let fileName = e.target.name;
    const file = e.target.files[0];
    dispatch(actions.persist_store({ loader: true }));
    setIsShow(true);
    setSending(true);
    let data = await uploadFileMulti_(
      dispatch,
      file,
      setSelectedFile,
      setPreviewImage,
      setValidationErrors,
      fileName
    );
    setIsShow(false);
    dispatch(actions.persist_store({ loader: false }));
    data = data?.length > 0 ? data : [];
    if (data?.length > 0) {
      return data[0];
    }
    setIsShow(false);
  };

  return (
    <>
      <div className="row">
        <div className="form-group col-md-12">
          <div className="d-flex align-items-center justify-content-between">
            <div className="left">
              <label htmlFor="name" className="m-0">
                Add Academy Details*
              </label>
            </div>
            <div className="right">
              <button
                type="button"
                className="btn btn-gradient-primary btn-sm"
                onClick={handleAddForm}
              >
                {" "}
                + Add
              </button>
            </div>
          </div>
          <br />
          <div>
            {academyData?.map((form, index) => (
              <div
                className="d-flex align-itesm-start gap-10 p-3 rounded my-3"
                style={{ background: "#f1f1f1" }}
              >
                <div className="row" key={index}>
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Academy Name</label>
                    <input
                      type="text"
                      placeholder="Academy Name"
                      className="form-control"
                      value={form.academy_name}
                      onChange={(event) =>
                        handleChangeForm(index, event, "academy_name")
                      }
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Academy Location</label>
                    <GooglePlacesMulti2
                      index={index}
                      setAcademyData={setAcademyData}
                      fieldNames={[
                        "academy_location",
                        "academy_latitude",
                        "academy_longitude",
                      ]}
                      value={form.academy_location}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Academy Description</label>

                    <textarea
                      type="text"
                      className="form-control"
                      id="exampleInputName1"
                      placeholder="Academy Description"
                      value={form.academy_description}
                      onChange={(event) =>
                        handleChangeForm(index, event, "academy_description")
                      }
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label for="exampleInputName1">Academy Image</label>
                    <div
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onClick={handleClick2}
                    >
                      <input
                        type="file"
                        class="form-control file-upload-info"
                        disabled=""
                        placeholder="Upload Image"
                        name="academy_image"
                        style={{ display: "none" }}
                        onChange={(event) =>
                          handleChangeForm(index, event, "academy_image")
                        }
                        ref={fileInputRef2}
                      />
                      <div>
                        {previewImage?.image ? (
                          <img
                            src={previewImage.image}
                            alt="Preview"
                            className="img-custom"
                          />
                        ) : form?.academy_image ? (
                          <img
                            src={form?.academy_image}
                            alt="Preview"
                            className="img-custom"
                          />
                        ) : (
                          <img
                            src={MAIN__DUMMY_}
                            alt="Default Preview"
                            className="img-custom"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {index > 0 && (
                  <div className=" my-4">
                    <button
                      type="button"
                      className="btn px-2 btn-gradient-primary btn-sm"
                      onClick={() => handleRemoveForm(index)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 34 34"
                        fill="none"
                      >
                        <path
                          d="M10.7876 28.3333C10.1359 28.3333 9.59192 28.1152 9.15559 27.6788C8.71831 27.2415 8.49967 26.6971 8.49967 26.0454V8.49999H7.08301V7.08333H12.7497V5.99249H21.2497V7.08333H26.9163V8.49999H25.4997V26.0454C25.4997 26.6971 25.2815 27.2411 24.8452 27.6774C24.4079 28.1147 23.8634 28.3333 23.2118 28.3333H10.7876ZM13.8943 24.0833H15.311V11.3333H13.8943V24.0833ZM18.6883 24.0833H20.105V11.3333H18.6883V24.0833Z"
                          fill="#fff"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
